import './App.css';
import "babel-polyfill";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route } from "react-router-dom";
import LoginContainer from './containers/LoginContainer.js';
import ExpirationLoginContainer from './containers/ExpirationLoginContainer.js';
import MenuContainer from './containers/MenuContainer.js';
import SessionsContainer from './containers/SessionsContainer.js';
import AnalysisContainer from './containers/AnalysisContainer.js';
import ProposalsContainer from './containers/ProposalsContainer.js';
import EmSessionContainer from './containers/EmSessionContainer.js';
import EmMovieContainer from './containers/EmMovieContainer.js';
import MXSessionContainer from './containers/MXSessionContainer.js';
import MXWorflowContainer from './containers/MXWorflowContainer.js';
import Footer from './components/Footer.js';
import { loadConfiguration } from './actions/configuration.js';

import SelectionContainer from './containers/SelectionContainer.js';
import JobsContainer from './containers/JobsContainer.js';
import tinyParams from 'tiny-params';

import SaxsDataCollectionReductionContainer from './containers/saxs/SaxsDataCollectionReductionContainer';
import SaxsAbInitioContainer from './containers/saxs/SaxsAbInitioContainer';
import SaxsDataCollectionSummaryContainer from './containers/saxs/SaxsDataCollectionSummaryContainer';

class App extends Component {
    componentDidMount() {
        this.props.loadConfiguration()
    }

    render() {

        return (
            <Router>
                <div>
                    <MenuContainer />
                    <LoginContainer />
                    <ExpirationLoginContainer></ExpirationLoginContainer>


                    <Route exact path="/" component={SessionPage} />
                    <Route exact path="/home" component={SessionPage} />
                    <Route exact path="/proposals" component={ProposalPage} />
                    <Route exact path="/sessions" component={SessionPage} />

                    <Route exact path="/sessions/dates/:startDate/:endDate"
                        render={(props) => <SessionPage {...props} ></SessionPage>}
                    />

                    <Route exact path="/sessions/proposal/:proposal"
                        render={(props) => <SessionPage {...props} ></SessionPage>}
                    />



                    <Route exact path="/sessions/mx/proposal/:proposalName/session/:sessionId/datasets" component={MXSessionPage} />
                    <Route exact path="/sessions/mx/proposal/:proposalName/session/:sessionId/workflow/:workflowId/steps/:workflowStepIds" component={MXWorflowPage} />

                    <Route exact path="/sessions/saxs/proposal/:proposalName/session/:sessionId/experiments" component={SaxsExperimentsAndDatasetPage} />
                    <Route exact path="/sessions/saxs/proposal/:proposalName/session/:sessionId/experiments/:experimentId/dataCollection/:dataCollectionId/reduction" component={SaxsDataCollectionReductionPage} />
                    <Route exact path="/sessions/saxs/proposal/:proposalName/session/:sessionId/experiments/:experimentId/dataCollection/:dataCollectionId/abinitio" component={SaxsDataCollectionAbInitioPage} />

                    <Route exact path="/sessions/em/proposal/:proposalName/session/:sessionId/datasets" component={EmSessionPage} />
                    <Route exact path="/sessions/em/proposal/:proposalName/datacollection/:dataCollectionId/movies" component={EmMoviePage} />


                    <Route exact path="/selected" render={(props) => <SelectionPage {...props} ></SelectionPage>} />

                    <Route exact path="/analysis/:tool" render={(props) => <AnalysisPage {...props} ></AnalysisPage>} />

                    <Route exact path="/jobs" render={(props) => <JobsPage {...props} ></JobsPage>} />


                    <Footer></Footer>
                </div>
            </Router>
        );
    }

}

function JobsPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <JobsContainer></JobsContainer>
    </div>;
}


function MXWorflowPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <MXWorflowContainer proposal={props.match.params.proposalName} sessionId={props.match.params.sessionId} workflowStepIds={props.match.params.workflowStepIds} workflowId={props.match.params.workflowId}></MXWorflowContainer>
    </div>;
}

function ProposalPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px', marginBottom: '70px' }}>
        <ProposalsContainer></ProposalsContainer>
    </div>;
}

function SessionPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px', marginBottom: '70px' }}>
        <SessionsContainer history={props.history} proposal={props.match.params.proposal} startDate={props.match.params.startDate} endDate={props.match.params.endDate} ></SessionsContainer>
    </div>;
}

function AnalysisPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <AnalysisContainer tool={props.match.params.tool} params={tinyParams(window.location.href)} ></AnalysisContainer>
    </div>;
}

function SaxsExperimentsAndDatasetPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <SaxsDataCollectionSummaryContainer sessionId={props.match.params.sessionId} proposal={props.match.params.proposalName} />
    </div>;
}


function SaxsDataCollectionReductionPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <SaxsDataCollectionReductionContainer
            experimentId={props.match.params.experimentId}
            dataCollectionId={props.match.params.dataCollectionId}
            proposal={props.match.params.proposalName}
            sessionId={props.match.params.sessionId} />
    </div>;
}


function SaxsDataCollectionAbInitioPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <SaxsAbInitioContainer
            //experimentId={props.match.params.experimentId}
            dataCollectionId={props.match.params.dataCollectionId}
            proposal={props.match.params.proposalName}
        //sessionId={props.match.params.sessionId} 
        />
    </div>;
}




function EmSessionPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <EmSessionContainer sessionId={props.match.params.sessionId} proposal={props.match.params.proposalName} ></EmSessionContainer>
    </div>;
}

function EmMoviePage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <EmMovieContainer dataCollectionId={props.match.params.dataCollectionId} proposal={props.match.params.proposalName} ></EmMovieContainer>
    </div>;
}

function MXSessionPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px' }}>
        <MXSessionContainer sessionId={props.match.params.sessionId} proposal={props.match.params.proposalName} ></MXSessionContainer>
    </div>;
}

function SelectionPage(props) {
    return <div style={{ marginTop: '30px', marginLeft: '30px', marginRight: '30px', marginBottom: '70px' }}>
        <SelectionContainer ></SelectionContainer>
    </div>;
}

function mapStateToProps(state) {
    return {
        user: state.user,
        sessions: state.sessions,
        configuration: state.configuration
    };
}



function mapDispatchToProps(dispatch) {
    return {
        loadConfiguration: () => dispatch(loadConfiguration())

    };
}



export default (connect(
    mapStateToProps,
    mapDispatchToProps
)(App));




// WEBPACK FOOTER //
// ./src/App.js